import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const WidgetWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  justify-content: space-between;
  width: 100%;
  padding: ${Spacing.S8} ${Spacing.S24};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  cursor: pointer;
`
